module.exports = __webpack_public_path__ + "img/ballon-shooting.a0c26a65.png";